"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettify = void 0;
const types_1 = require("../../types");
const style_1 = require("../../style");
const code_1 = require("../../code");
const suggest_1 = require("../../suggest");
const schema_1 = require("../../schema");
function prettify(context) {
    const { dataPath, error: { params: { additionalProperty } } } = types_1.getTypedContext(context);
    const [prePath, pathExpr, postPath] = style_1.pathDescription(context, 'object');
    const possibles = schema_1.getPossibleProperties(context.schema, dataPath);
    const title = style_1.style.title(`The ${prePath}`, context) +
        pathExpr +
        style_1.style.title(`${postPath} should not have the property `, context) +
        style_1.style.pathDescription(additionalProperty, context) +
        suggest_1.formatSuggestions(suggest_1.suggest(additionalProperty, possibles), context, { untyped: true, isSuggestion: true });
    const codeFrame = code_1.printCode('remove or rename ' +
        style_1.style.pathDescription(`"${additionalProperty}"`, context), context.parsedJson, {
        dataPath: dataPath.dotOnly + "." + additionalProperty,
        markIdentifier: true,
    });
    return { title, codeFrame };
}
exports.prettify = prettify;
